export const ALPHABET = {
  en: [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ],
  ar: [
    'ا',
    'ب',
    'ت',
    'ث',
    'ج',
    'ح',
    'خ',
    'د',
    'ذ',
    'ر',
    'ز',
    'س',
    'ش',
    'ص',
    'ض',
    'ط',
    'ظ',
    'ع',
    'غ',
    'ف',
    'ق',
    'ك',
    'ل',
    'م',
    'ن',
    'ه',
    'و',
    'ي',
  ],
  sy: [
    'ܐ',
    'ܒ',
    'ܓ',
    'ܕ',
    'ܗ',
    'ܘ',
    'ܙ',
    'ܚ',
    'ܛ',
    'ܝ',
    'ܟ',
    'ܠ',
    'ܡ',
    'ܢ',
    'ܣ',
    'ܥ',
    'ܦ',
    'ܨ',
    'ܩ',
    'ܪ',
    'ܫ',
    'ܬ',
  ],
};

export const PAGE_SIZE = 10;
export const ALPH_LANGS = [
  { value: 'eng_word', label: 'English' },
  { value: 'arb_word', label: 'Arabic' },
  { value: 'syr_word', label: 'Syriac' },
];
export const ALPH_POSITIONS = [
  { value: 'first', label: 'First Letter' },
  { value: 'last', label: 'Last Letter' },
];
export const SORTABLE_COLUMNS = [
  { key: 'eng_word', label: 'Name' },
  { key: 'gender', label: 'Gender' },
  { key: 'category', label: 'Category' },
  { key: 'origin', label: 'Origin' },
];
export const CATEGORIES = ['Biblical', 'Historical', 'Modern', 'Traditional'];
